import { Link } from "react-router-dom";
import {
  Compass,
  Eye,
  HeartHandshake,
  Lightbulb,
  Layers,
  Users,
  ArrowUpRight,
  CheckCircle2,
} from "lucide-react";
import PageHero from "../../components/shared/PageHero";
import CtaBand from "../../components/shared/CtaBand";
import AnimatedCounter from "../../components/shared/AnimatedCounter";
import { STATS, ABOUT, AUDIENCES } from "../../data/content";
import "./AboutPage.css";

export default function AboutPage() {
  return (
    <div className="about-page">
      <PageHero
        badge="About Poonji Mitra"
        title="India's complete digital financial partner"
        subtitle="From Jaipur to every investor and founder — portfolio management, wealth products, business finance, tax, and compliance under one trusted roof."
        actions={[
          { label: "Book Free Consultation", to: "/contact", primary: true },
          { label: "Meet the Team", to: "/team" },
        ]}
      />

      <section className="pm-section about-story">
        <div className="pm-container about-story__grid">
          <div>
            <span className="pm-badge">
              <span className="pm-badge-dot" />
              Our Story
            </span>
            <h2 className="pm-section-title">Built to end fragmented finance</h2>
            <p className="pm-section-sub">{ABOUT.story}</p>
          </div>
          <div className="about-story__card pm-card">
            <HeartHandshake size={28} className="about-icon" />
            <h3>Relationship over products</h3>
            <p>
              We partner for the long term — with quarterly reviews, transparent
              advice, and education that helps you make confident decisions.
            </p>
          </div>
        </div>
      </section>

      <section className="pm-section about-mv">
        <div className="pm-container">
          <div className="about-mv__grid">
            <article className="pm-card about-mv__card">
              <Compass size={26} className="about-icon" />
              <h3>Mission</h3>
              <p>{ABOUT.mission}</p>
            </article>
            <article className="pm-card about-mv__card">
              <Eye size={26} className="about-icon" />
              <h3>Vision</h3>
              <p>{ABOUT.vision}</p>
            </article>
          </div>
        </div>
      </section>

      <section className="pm-section about-why">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            Why Us
          </span>
          <h2 className="pm-section-title">Why Poonji Mitra</h2>
          <p className="pm-section-sub">
            Professional-grade guidance with the clarity families and founders
            deserve.
          </p>
          <ul className="about-why__list">
            {ABOUT.why.map((item) => (
              <li key={item} className="pm-card">
                <CheckCircle2 size={20} className="about-icon" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="pm-section about-philosophy">
        <div className="pm-container about-philosophy__grid">
          <article className="pm-card">
            <Lightbulb size={26} className="about-icon" />
            <h3>Investment Philosophy</h3>
            <p>{ABOUT.philosophy}</p>
          </article>
          <article className="pm-card">
            <Layers size={26} className="about-icon" />
            <h3>End-to-End Solutions</h3>
            <p>{ABOUT.endToEnd}</p>
          </article>
        </div>
      </section>

      <section className="pm-section about-audiences">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            Who We Serve
          </span>
          <h2 className="pm-section-title">Built for every stage of growth</h2>
          <div className="about-audiences__row">
            {AUDIENCES.map((a) => (
              <div key={a} className="pm-card about-audiences__chip">
                <Users size={18} className="about-icon" />
                {a}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pm-section about-stats">
        <div className="pm-container">
          <span className="pm-badge">
            <span className="pm-badge-dot" />
            Impact
          </span>
          <h2 className="pm-section-title">Numbers that reflect trust</h2>
          <div className="about-stats__grid">
            {STATS.map((s) => (
              <div key={s.label} className="pm-card about-stats__item">
                <AnimatedCounter
                  value={s.value}
                  prefix={s.prefix || ""}
                  suffix={s.suffix || ""}
                  className="about-stats__value"
                />
                <span className="about-stats__label">{s.label}</span>
              </div>
            ))}
          </div>
          <Link to="/services" className="pm-btn pm-btn-outline about-stats__cta">
            Explore Our Services
            <ArrowUpRight size={16} />
          </Link>
        </div>
      </section>

      <CtaBand
        title="Ready to grow with clarity?"
        subtitle="Talk to our CFA and CA-led team for a free consultation tailored to your goals."
        primary={{ label: "Book Free Consultation", to: "/contact" }}
        secondary={{ label: "Talk to an Expert", to: "/contact" }}
      />
    </div>
  );
}
